export default "__VITE_ASSET__cc547675__$_?component__"